import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatDate } from '~/utils/date';

import { getStockQuantityColumns } from './stockQuantityColumns';

import type { TypeStockDate } from '~/types/stock.types';

const formatDay = (value: string | undefined): string => formatDate(value, 'YYYY.MM.DD') ?? '-';

/**
 * [재고관리 > 유통기한별 조회] 페이지 테이블
 */
const getStockDateColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeStockDate>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'alterCode',
      header: '상품 바코드',
      size: 150,
    },
    {
      accessorKey: 'skuCode',
      header: 'SKU코드',
      size: 140,
    },
    {
      accessorKey: 'clusterName',
      header: '보관 센터',
      size: 80,
    },
    {
      accessorKey: 'stockType',
      header: '재고 유형',
      size: 80,
    },
    {
      accessorKey: 'temperatureType',
      header: '보관 유형',
      size: 92,
    },
    {
      accessorKey: 'manufactureDate',
      header: '제조일',
      size: 100,
      cell: ({ getValue }) => formatDay(getValue<string | undefined>()),
    },
    {
      accessorKey: 'expiredDate',
      header: '소비기한',
      size: 100,
      cell: ({ getValue }) => formatDay(getValue<string | undefined>()),
    },
    {
      accessorKey: 'salesDeadLineDate',
      header: '판매 마감일',
      size: 100,
      cell: ({ getValue }) => formatDay(getValue<string | undefined>()),
    },
    {
      accessorKey: 'skuName',
      header: '상품명',
      minSize: 240,
      meta: { flex: true },
    },
    ...getStockQuantityColumns<TypeStockDate>(),
  ];

  return { columnDefs };
};

export default getStockDateColumnDefs;
